export default [
  {
    path: "/ssologin",
    component: resolve => require(['@/page/SSOLogin.vue'], resolve),
  },
  {
    path: "/iframe",
    component: resolve => require(['@/components/iframe/Index'], resolve),
    children: [
      {
        path: 'histroyData/detail',
        component: resolve => require(['@/components/iframe/histroyData'], resolve),
      },
      {
        path: 'dataAnalysis/teamData',
        component: resolve => require(['@/components/iframe/TeamData'], resolve),
      },
      {
        path: 'dataAnalysis/playerData',
        component: resolve => require(['@/components/iframe/PlayerData'], resolve),
      },
      {
        path: 'matchSchedule/regularSeason',
        // path: 'matchSchedule/playOffs',
        component: resolve =>
          require(['@/components/iframe/matchSchedule/common/RegularSeason/RegularSeason'], resolve)
      },
      {
        path: 'matchSchedule/playOffs',
        // path: 'matchSchedule/regularSeason',
        component: resolve =>
          require(['@/components/iframe/matchSchedule/common/playOffs/PlayOffs'], resolve)
      },
      {
        path: 'matchData/teamData',
        component: resolve =>
          require(['@/components/iframe/matchData/common/TeamData'], resolve)
      },
      {
        path: 'matchData/mapData',
        component: resolve =>
          require(['@/components/iframe/matchData/common/MapData'], resolve)
      },
      // {
      //   path: 'cfs/teamScorePC',
      //   component: resolve =>
      //     // require(['@/components/iframe/matchData/common/MapData'], resolve)
      //   require(['@/components/iframe/matchSchedule/common/teamScore/TeamRank'], resolve)
      // },
      // {
      //   path: 'cfs/matchListPC',
      //   component: resolve =>
      //     // require(['@/components/iframe/matchData/common/MapData'], resolve)
      //     require(['@/components/iframe/matchSchedule/common/teamScore/Schedule'], resolve)
      // }
    ],
  },
  {
    path: "/iframe_zoom",
    component: resolve => require(['@/components/iframe/Index_zoom'], resolve),
    children: [
      {
        path: 'histroyData/detail',
        component: resolve => require(['@/components/iframe/histroyData'], resolve),
      },
      {
        path: 'dataAnalysis/teamData',
        component: resolve => require(['@/components/iframe/TeamData'], resolve),
      },
      {
        path: 'dataAnalysis/playerData',
        component: resolve => require(['@/components/iframe/PlayerData'], resolve),
      },
      {
        path: 'matchSchedule/regularSeason',
        // path: 'matchSchedule/playOffs',
        component: resolve =>
          require(['@/components/iframe/matchSchedule/common/RegularSeason/RegularSeason'], resolve)
      },
      {
        path: 'matchSchedule/playOffs',
        // path: 'matchSchedule/regularSeason',
        component: resolve =>
          require(['@/components/iframe/matchSchedule/common/playOffs/PlayOffs'], resolve)
      },
      {
        path: 'matchData/teamData',
        component: resolve =>
          require(['@/components/iframe/matchData/common/TeamData'], resolve)
      },
      {
        path: 'matchData/mapData',
        component: resolve =>
          require(['@/components/iframe/matchData/common/MapData'], resolve)
      },
      // {
      //   path: 'cfs/teamScorePC',
      //   component: resolve =>
      //     // require(['@/components/iframe/matchData/common/MapData'], resolve)
      //   require(['@/components/iframe/matchSchedule/common/teamScore/TeamRank'], resolve)
      // },
      // {
      //   path: 'cfs/matchListPC',
      //   component: resolve =>
      //     // require(['@/components/iframe/matchData/common/MapData'], resolve)
      //     require(['@/components/iframe/matchSchedule/common/teamScore/Schedule'], resolve)
      // }
    ],
  },
  {
    path: '/judge/login',
    component: resolve => require(['@/components/judge/JudgeLogin'], resolve),
    meta: {
      site: 'judge',
      judgeLogin: false,
      title: '裁判登录'
    }
  },
  {
    path: '/judge',
    component: resolve => require(['@/components/judge/Index'], resolve),
    meta: {
      site: 'judge',
      judgeLogin: false,
    },
    children: [{
      path: 'live_manager',
      component: resolve => require(['@/components/judge/LiveManager'], resolve),
      meta: {
        site: 'judge',
        judgeLogin: true,
        title: '直播控制'
      }
    }, {
      path: 'game_manager',
      component: resolve => require(['@/components/judge/GameManager'], resolve),
      meta: {
        site: 'judge',
        judgeLogin: true,
        title: '比赛管理'
      }
    },],
  },
  {
    path: '/iframe/cfs/teamScorePC',
    component: resolve =>
      // require(['@/components/iframe/matchData/common/MapData'], resolve)
      require(['@/components/iframe/matchSchedule/common/teamScore/TeamRank'], resolve)
  },
  {
    path: '/iframe/cfs/matchListPC',
    component: resolve =>
      // require(['@/components/iframe/matchData/common/MapData'], resolve)
      require(['@/components/iframe/matchSchedule/common/teamScore/Schedule'], resolve)
  },
  {
    path: '/tool/create_player_banner',
    component: resolve => require(['@/components/tool/CreatePlayerBanner'], resolve)
  },
  {
    path: '/tool/upload_excel',
    component: resolve => require(['@/components/tool/UploadExcel'], resolve)
  },
  {
    path: '/tool',
    component: resolve => require(['@/components/tool/DataToolsNew'], resolve),
    children: [
      {
        path: 'poster/fiveKills',
        component: resolve => require(['@/components/tool/poster/fiveKills/FiveKills'], resolve),
      },
      {
        path: 'poster/dataChart',
        component: resolve => require(['@/components/tool/poster/dataChart/index'], resolve),
      },
      {
        path: 'poster/poster',
        component: resolve => require(['@/components/tool/poster/poster/index'], resolve),
      },
      {
        path: 'poster/game',
        component: resolve => require(['@/components/tool/poster/game/Game'], resolve),
      }
    ],
  },
  {
    path: '/milestone/milestone',
    component: resolve => require(['@/components/milestone/MileStone'], resolve),
    meta: {
      site: 'milestone',
      title: '里程碑'
    }
  },
  {
    path: '/cfpl_tool',
    component: resolve => require(['@/components/cfpl_tool/Index'], resolve),
    children: [
      {
        path: 'milestone',
        component: resolve => require(['@/components/cfpl_tool/milestone/Milestone'], resolve),
      },
    ],
  },
  {
    path: '/live',
    meta: {
      site: 'judge',
      judgeLogin: false,
    },
    component: resolve => require(['@/components/live/Index'], resolve),
    children: [
      {
        path: 'live',
        meta: {
          site: 'judge',
          judgeLogin: true,
        },
        component: resolve => require(['@/components/live/live/Live'], resolve),
      },
    ],
  },
  // {
  //   path: 'live',
  //   component: resolve => require(['@/components/live/live/Live'], resolve),
  // },
  {
    name: 'main-view',
    path: '/main',
    meta: {
      requireLogin: true
    },
    component: () => import("@/layout/BasicLayout.vue"),
    children: [
      {
        name: 'matrix-player',
        path: 'matrix/player',
        meta: {
          requireLogin: true
        },
        component: () => import("@/page/matrix/player/index.vue"),
      },
      {
        name: 'matrix-team',
        path: 'matrix/team',
        meta: {
          requireLogin: true
        },
        component: () => import("@/page/matrix/team/index.vue"),
      },
      {
        name: 'matrix-milestone',
        path: 'matrix/milestone',
        component: resolve => require(['@/components/cfpl_tool/milestone/Milestone'], resolve),
      },
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/routrPC.js